import React from 'react'
import { useSelector } from 'react-redux'

import {
  MultipleSelect,
  MultipleSelectExtraProps,
} from 'src/components/custom/MutipleSelects/MultipleSelect'
import { selectOwnWarehouseLite } from 'src/selectors/warehouse.selector'

interface SelectUsersProps extends MultipleSelectExtraProps {
  label: string
  onChange: (users: ISelect[]) => void
}
export const SelectWarehouses = ({
  label,
  onChange,
  noMultiple = false,
  clear = false,
}: SelectUsersProps) => {
  const warehouses = useSelector(selectOwnWarehouseLite)

  return (
    <MultipleSelect
      noMultiple={noMultiple}
      options={warehouses}
      label={label}
      onChange={onChange}
      clear={clear}
    />
  )
}
